/* components/ui/ToggleChips.jsx — мультивыбор чипами: «Все» + переключаемые значения.

   Ряд, где можно выбрать несколько значений сразу или не выбирать ничего: дни недели
   «Производительности», должности «Персонала», фильтры панели «Столы». Пустой выбор
   означает «Все» — отдельного состояния «ничего не выбрано» у такого ряда нет, иначе
   отчёт показал бы пустоту там, где человек просто снял последний чип.

   Правила (контракт work/analytics-pack-oct/contracts/ui-components.md, раздел 4):
   • «Все» очищает выбор; чип добавляет или убирает себя; снят последний — снова «Все»;
   • порядок выбранного — как у вариантов, а не как кликали: значение уходит в адрес и
     в запрос, и один и тот же выбор должен давать одну и ту же строку;
   • кнопки с aria-pressed в role="group" с подписью; ряд переносится строками, на
     пальце высота кнопки — 44px.

   ХЕНДОФФ → frontend/components/common/. */
import React from 'react';

/** Следующий выбор после нажатия. clicked = null — нажата «Все». */
export function toggleChipValue(value, clicked, options) {
  if (clicked == null) return [];
  const set = new Set(value || []);
  if (set.has(clicked)) set.delete(clicked); else set.add(clicked);
  return (options || []).map((o) => o.value).filter((v) => set.has(v));
}

/**
 * options  — [{ value, label, count?, title? }];
 * value    — выбранные значения, [] = «Все»;
 * onChange — (next) => …;
 * allLabel — подпись «Все»; ariaLabel — подпись группы; className — класс ряда.
 */
export function ToggleChips({ options = [], value = [], onChange, allLabel = 'Все', ariaLabel, className }) {
  const sel = value || [];
  const pick = (clicked) => onChange && onChange(toggleChipValue(sel, clicked, options));
  const all = sel.length === 0;
  return (
    <div className={'toggle-chips' + (className ? ' ' + className : '')} role="group" aria-label={ariaLabel}>
      <button type="button" className={'toggle-chip' + (all ? ' is-active' : '')}
        aria-pressed={all} onClick={() => pick(null)}>{allLabel}</button>
      {options.map((o) => {
        const on = sel.includes(o.value);
        return (
          <button type="button" key={o.value} className={'toggle-chip' + (on ? ' is-active' : '')}
            aria-pressed={on} title={o.title} onClick={() => pick(o.value)}>
            {o.label}
            {/* Пробел текстом: иначе имя кнопки для экранного диктора слипается
                («Официант14»), а глазами его съедает flex-зазор. */}
            {o.count != null && <>{' '}<span className="toggle-chip__count num">{o.count}</span></>}
          </button>
        );
      })}
    </div>
  );
}
